@if (title() && linkLists(); as linkLists) {
  <wl-link-list-section
    [title]="title()!"
    [linkLists]="linkLists"
  ></wl-link-list-section>
}
